module.exports = __webpack_public_path__ + "img/19.acc8b1c9.png";